import VerificationBypassPage from "./VerificationBypassPage";

export default VerificationBypassPage;
